import { Component, OnInit } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute } from "@angular/router";
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common'

@Component({
  selector: 'app-view-doc',
  templateUrl: './view-doc.component.html',
  styleUrls: ['./view-doc.component.scss']
})
export class ViewDocComponent implements OnInit {
  p: number = 1;
  itemsPerPage : number = 10;
  items: any;
  type!: any;
  id!: any;
  arr: any;
  docs: any = [];
  images: any = [];
  categ:any;
  title:any;

  private apiURL = environment.apiURL;

  constructor(private route: ActivatedRoute, private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService, private location: Location) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['Id']; 
      this.type = params['type'];
      this.categ = params['categ'];

    })
    if(this.categ=='training')
      this.getTrainingDocuments()
    else if(this.categ=='awp')
      this. getAWPDocuments()
  }
  
  back(): void {
    this.location.back()
  }

  getTrainingDocuments() {
    debugger
    // var images=any;
    this.spinnerService.show();

    this.fswService.getTrainingFiles(this.id)
      .subscribe(res => {
        this.arr = res;
        this.title = res[0].trainingTitle;
        this.arr.forEach((item: any) => {
          let filename = item.filePath.replace(/^.*[\\\/]/, '')
          item.filename = filename;

            this.docs.push({filename:item.filename,filepath:this.apiURL+'/fsw/document-view'+item.filePath} )
    
          this.spinnerService.hide();
        })

      });

  }
  getAWPDocuments() {
    debugger
    // var images=any;
    this.spinnerService.show();

    this.fswService.getAwpFileUploadsWithAwpId(this.id)
      .subscribe(res => {
        this.arr = res;
        this.title = res[0].programTitle;
        this.arr.forEach((item: any) => {
          let filename = item.filePath.replace(/^.*[\\\/]/, '')
          item.filename = filename;
         
            this.docs.push({filename:item.filename,filepath:this.apiURL+'/fsw/document-view'+item.filePath} )
         
          this.spinnerService.hide();
        })

      });

  }
  

}
